// import React, { useEffect, useMemo, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "../styles/leavereport.css";

// const LeaveReport = () => {
//     const fromDateRef = useRef(null);
//     const toDateRef = useRef(null);
//     const navigate = useNavigate();

//     const [leaves, setLeaves] = useState([]);
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [manager, setManager] = useState("");
//     const [fromDate, setFromDate] = useState("");
//     const [toDate, setToDate] = useState("");

//     const [selectedEmployee, setSelectedEmployee] = useState(null);
//     const [theme, setTheme] = useState("light");

//     useEffect(() => {
//         fetchLeaves();
//     }, []);
//     const [employeeSearch, setEmployeeSearch] = useState("");

//     const fetchLeaves = async () => {

//         try {

//             const storedUser = localStorage.getItem("userData");

//             const authUser = JSON.parse(storedUser) || {};

//             const viewerId =
//                 authUser.EmpId ||
//                 authUser.empid ||
//                 "";

//             const role =
//                 authUser.Role ||
//                 authUser.role ||
//                 "";

//             const res = await fetch(
//                 `/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             console.log("FULL API RESPONSE:", data);

//             if (data.success) {

//                 console.log("LEAVES:", data.leaves);

//                 setLeaves(data.leaves || []);
//                 setAllEmployees(data.employees || []);

//                 console.log("FIRST LEAVE OBJECT:", data.leaves[0]);

//             } else {

//                 console.log("API FAILED:", data);

//             }

//         } catch (err) {

//             console.error(err);

//         } finally {

//             setLoading(false);

//         }
//     };

//     // GET MANAGER NAME FROM EMPLOYEE TABLE
//     const getManagerName = (managerId) => {

//         console.log("SEARCHING MANAGER:", managerId);

//         console.log("EMPLOYEE LIST:", allEmployees);

//         const manager = allEmployees.find(
//             emp => String(emp.EmpId) === String(managerId)
//         );

//         console.log("FOUND MANAGER:", manager);

//         return manager
//             ? manager.full_name
//             : `Manager ${managerId}`;
//     };

//     // UNIQUE MANAGERS
//     const managers = useMemo(() => {

//         const uniqueManagers = [];

//         leaves.forEach(l => {

//             if (!l.ManagerID) return;

//             const managerName = getManagerName(l.ManagerID);

//             const alreadyExists = uniqueManagers.find(
//                 m => m.id === l.ManagerID
//             );

//             if (!alreadyExists) {

//                 uniqueManagers.push({
//                     id: l.ManagerID,
//                     name: managerName
//                 });

//             }

//         });

//         return uniqueManagers;

//     }, [leaves, allEmployees]);

//     // FILTERED LEAVES
//     const filteredLeaves = useMemo(() => {

//         return leaves.filter(l => {

//             const leaveDate = new Date(l.fromdate);

//             const employeeName =
//                 `${l.FirstName} ${l.LastName}`.toLowerCase();

//             const matchesManager =
//                 !manager ||
//                 String(l.ManagerID) === String(manager);

//             const matchesFrom =
//                 !fromDate ||
//                 leaveDate >= new Date(fromDate);

//             const matchesTo =
//                 !toDate ||
//                 leaveDate <= new Date(toDate);

//             const matchesEmployee =
//                 !employeeSearch ||
//                 employeeName.includes(
//                     employeeSearch.toLowerCase()
//                 );

//             return (
//                 matchesManager &&
//                 matchesFrom &&
//                 matchesTo &&
//                 matchesEmployee
//             );

//         });

//     }, [
//         leaves,
//         manager,
//         fromDate,
//         toDate,
//         employeeSearch
//     ]);
//     // SUMMARY
//     const summary = useMemo(() => {

//         return {
//             approved: filteredLeaves.filter(
//                 l => l.Status === "1"
//             ).length,

//             rejected: filteredLeaves.filter(
//                 l => l.Status === "2"
//             ).length,

//             pending: filteredLeaves.filter(
//                 l =>
//                     l.Status === "0" ||
//                     l.Status === null
//             ).length
//         };

//     }, [filteredLeaves]);

//     // EMPLOYEE GROUPING
//     const employeeWise = useMemo(() => {

//         const grouped = {};

//         filteredLeaves.forEach(l => {

//             const emp =
//                 `${l.FirstName} ${l.LastName}`;

//             if (!grouped[emp]) {
//                 grouped[emp] = [];
//             }

//             grouped[emp].push(l);

//         });

//         return grouped;

//     }, [filteredLeaves]);

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className={`managerwiseleavereport-container ${theme}`}>

//             {/* TOP HEADER */}
//             <div className="managerwiseleavereport-topbar">

//                 {/* LEFT */}
//                 <div className="managerwiseleavereport-leftsection">

//                     <button
//                         className="managerwiseleavereport-backbtn"
//                         onClick={() => navigate(-1)}
//                     >
//                         ← Back To Leave Management
//                     </button>

//                 </div>

//                 {/* CENTER */}
//                 <div className="managerwiseleavereport-centersection">

//                     <h1 className="managerwiseleavereport-title">
//                         Manager Leave Report
//                     </h1>

//                     <p className="managerwiseleavereport-subtitle">
//                         Analyze employee leave requests based on manager and duration
//                     </p>

//                 </div>

//                 {/* RIGHT */}
//                 <div className="managerwiseleavereport-rightsection">

//                     <button
//                         className="managerwiseleavereport-themebtn"
//                         onClick={() =>
//                             setTheme(
//                                 theme === "dark"
//                                     ? "light"
//                                     : "dark"
//                             )
//                         }
//                     >

//                         {
//                             theme === "dark"
//                                 ? "☀ Light Mode"
//                                 : "🌙 Dark Mode"
//                         }

//                     </button>

//                 </div>

//             </div>

//             {/* FILTER CARD */}
//             <div className="managerwiseleavereport-filtercard">

//                 <div className="managerwiseleavereportfiltergrid">

//                     {/* MANAGER */}
//                     <div className="managerwiseleavereportfiltergroup">

//                         <label
//                             style={{
//                                 color: theme === "dark"
//                                     ? "#ffffff"
//                                     : "#6b7280",
//                                 fontWeight: "700",
//                                 letterSpacing: "1px",
//                                 textTransform: "uppercase",
//                                 fontSize: "0.78rem"
//                             }}
//                         >
//                             Select Manager
//                         </label>

//                         <select
//                             value={manager}
//                             onChange={(e) =>
//                                 setManager(e.target.value)
//                             }
//                             className="managerwiseleavereportselect"
//                         >

//                             <option value="">
//                                 Choose Manager
//                             </option>

//                             {managers.map((m, idx) => (

//                                 <option
//                                     key={idx}
//                                     value={m.id}
//                                 >
//                                     {m.name}
//                                 </option>

//                             ))}

//                         </select>

//                     </div>

//                     {/* FROM DATE */}
//                     <div className="managerwiseleavereportfiltergroup">

//                         <label>
//                             From Date
//                         </label>

//                         <div className="managerwiseleavereportdatewrapper">

//                             <span
//                                 className="managerwiseleavereportcalendaricon"
//                                 onClick={() => fromDateRef.current?.showPicker()}
//                             >
//                                 📅
//                             </span>

//                             <input
//                                 ref={fromDateRef}
//                                 type="date"
//                                 value={fromDate}
//                                 onChange={(e) =>
//                                     setFromDate(e.target.value)
//                                 }
//                                 className="managerwiseleavereportinput"
//                             />

//                         </div>

//                     </div>

//                     {/* TO DATE */}
//                     <div className="managerwiseleavereportfiltergroup">

//                         <label>
//                             To Date
//                         </label>

//                         <div className="managerwiseleavereportdatewrapper">

//                             <span
//                                 className="managerwiseleavereportcalendaricon"
//                                 onClick={() => toDateRef.current?.showPicker()}
//                             >
//                                 📅
//                             </span>

//                             <input
//                                 ref={toDateRef}
//                                 type="date"
//                                 value={toDate}
//                                 onChange={(e) =>
//                                     setToDate(e.target.value)
//                                 }
//                                 className="managerwiseleavereportinput"
//                             />

//                         </div>

//                     </div>

//                 </div>

//             </div>

//             {/* ONLY SHOW DATA AFTER FILTER */}
//             {(manager && fromDate && toDate) && (

//                 <>

//                     {/* SUMMARY */}
//                     <div className="managerwiseleavereport-summarygrid">

//                         {/* APPROVED */}
//                         <div className="managerwiseleavereport-summarycard approved">

//                             <div className="managerwiseleavereport-summarylabel">
//                                 Approved
//                             </div>

//                             <div className="managerwiseleavereport-summaryvalue">
//                                 {summary.approved}
//                             </div>

//                         </div>

//                         {/* REJECTED */}
//                         <div className="managerwiseleavereport-summarycard rejected">

//                             <div className="managerwiseleavereport-summarylabel">
//                                 Rejected
//                             </div>

//                             <div className="managerwiseleavereport-summaryvalue">
//                                 {summary.rejected}
//                             </div>

//                         </div>

//                         {/* PENDING */}
//                         <div className="managerwiseleavereport-summarycard pending">

//                             <div className="managerwiseleavereport-summarylabel">
//                                 Pending
//                             </div>

//                             <div className="managerwiseleavereport-summaryvalue">
//                                 {summary.pending}
//                             </div>

//                         </div>

//                     </div>

//                     {/* LEAVE HISTORY TABLE */}
//                     <div className="managerwiseleavereport-tablecard">

//                         <div
//                             className="managerwiseleavereport-tableheader"
//                             style={{
//                                 position: "relative",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 marginBottom: "20px"
//                             }}
//                         >

//                            <div
//     style={{
//         textAlign: "center"
//     }}
// >

    

//     <p
//     style={{
//         marginTop: "10px",
//         marginBottom: "18px",
//         fontSize: "1.5rem",
//         fontWeight: "600",
//         color:
//             theme === "dark"
//                 ? "#468ae8"
//                 : "#4377e0"
//     }}
// >
//     Manager :
//     {" "}
//     {
//         managers.find(
//             m => String(m.id) === String(manager)
//         )?.name
//     }
// </p>

// <h2
//     style={{
//         margin: 0,
//         fontSize: "1.4rem",
//         fontWeight: "700",
//         letterSpacing: "0.5px",
//         color:
//             theme === "dark"
//                 ? "#ffffff"
//                 : "#111827"
//     }}
// >
//     Employee Leave History
// </h2>

// </div>
//                             {/* SEARCH BOX RIGHT SIDE */}
//                             <input
//                                 type="text"
//                                 placeholder="Search employee..."
//                                 value={employeeSearch}
//                                 onChange={(e) =>
//                                     setEmployeeSearch(e.target.value)
//                                 }
//                                 className="managerwiseleavereportinput"
//                                 style={{
//                                     position: "absolute",
//                                     right: "0",
//                                     width: "260px",
//                                     height: "42px",
//                                     color: theme === "dark" ? "#ffffff" : "#111827",
//                                     WebkitTextFillColor:
//                                         theme === "dark"
//                                             ? "#ffffff"
//                                             : "#111827",
//                                     background:
//                                         theme === "dark"
//                                             ? "rgba(255,255,255,0.08)"
//                                             : "#ffffff",
//                                     border:
//                                         theme === "dark"
//                                             ? "1px solid rgba(255,255,255,0.12)"
//                                             : "1px solid #d1d5db"
//                                 }}
//                             />

//                         </div>


//                         <table className="managerwiseleavereport-historytable">
//                             <thead>

//                                 <tr>

//                                     <th>
//                                         Sr No
//                                     </th>

//                                     <th>
//                                         Employee Name
//                                     </th>

//                                     <th>
//                                         Leave Unit
//                                     </th>

//                                     <th>
//                                         Leave Type
//                                     </th>

//                                     <th>
//                                         Duration
//                                     </th>

//                                     <th>
//                                         Status
//                                     </th>

//                                 </tr>

//                             </thead>

//                             <tbody>

//                                 {filteredLeaves.length > 0 ? (

//                                     filteredLeaves.map((leave, i) => (

//                                         <tr key={i}>

//                                             <td>
//                                                 {i + 1}
//                                             </td>

//                                             <td>
//                                                 {leave.FirstName}
//                                                 {" "}
//                                                 {leave.LastName}
//                                             </td>

//                                             <td>
//                                                 {leave.total}
//                                             </td>

//                                             <td>
//                                                 {leave.leavetype}
//                                             </td>

//                                             <td>
//                                                 {leave.fromdate}
//                                                 {" "}
//                                                 →
//                                                 {" "}
//                                                 {leave.todate}
//                                             </td>

//                                             <td>

//                                                 <span
//                                                     className={`managerwiseleavereport-status ${leave.Status === "1"
//                                                         ? "approved"
//                                                         : leave.Status === "2"
//                                                             ? "rejected"
//                                                             : "pending"
//                                                         }`}
//                                                 >

//                                                     {
//                                                         leave.Status === "1"
//                                                             ? "Approved"
//                                                             : leave.Status === "2"
//                                                                 ? "Rejected"
//                                                                 : "Pending"
//                                                     }

//                                                 </span>

//                                             </td>

//                                         </tr>

//                                     ))

//                                 ) : (

//                                     <tr>

//                                         <td
//                                             colSpan="6"
//                                             style={{
//                                                 textAlign: "center",
//                                                 padding: "30px"
//                                             }}
//                                         >
//                                             No leave records found
//                                         </td>

//                                     </tr>

//                                 )}

//                             </tbody>

//                         </table>

//                     </div>

//                 </>

//             )}

//         </div>
//     );
// };

// export default LeaveReport;














import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/leavereport.css";

const LeaveReport = () => {
    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);
    const navigate = useNavigate();

    const [leaves, setLeaves] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    const [loading, setLoading] = useState(true);

    const [manager, setManager] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [theme, setTheme] = useState("light");

    useEffect(() => {
        fetchLeaves();
    }, []);
    const [employeeSearch, setEmployeeSearch] = useState("");

    const fetchLeaves = async () => {

        try {

            const storedUser = localStorage.getItem("userData");

            const authUser = JSON.parse(storedUser) || {};

            const viewerId =
                authUser.EmpId ||
                authUser.empid ||
                "";

            const role =
                authUser.Role ||
                authUser.role ||
                "";

            const res = await fetch(
                `/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`,
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            console.log("FULL API RESPONSE:", data);

            if (data.success) {

                console.log("LEAVES:", data.leaves);

                setLeaves(data.leaves || []);
                setAllEmployees(data.employees || []);

                console.log("FIRST LEAVE OBJECT:", data.leaves[0]);

            } else {

                console.log("API FAILED:", data);

            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }
    };

    // GET MANAGER NAME FROM EMPLOYEE TABLE
    const getManagerName = (managerId) => {

    const foundManager = allEmployees.find(
        emp =>
            String(emp.EmpId).trim() ===
            String(managerId).trim()
    );

    return foundManager?.full_name || managerId;
};

    // UNIQUE MANAGERS
    const managers = useMemo(() => {

        const uniqueManagers = [];

        leaves.forEach(l => {

            if (!l.ManagerID) return;

            const managerName = getManagerName(l.ManagerID);

            const alreadyExists = uniqueManagers.find(
                m => m.id === l.ManagerID
            );

            if (!alreadyExists) {

                uniqueManagers.push({
                    id: l.ManagerID,
                    name: managerName
                });

            }

        });

        return uniqueManagers;

    }, [leaves, allEmployees]);

    // FILTERED LEAVES
    const filteredLeaves = useMemo(() => {

        return leaves.filter(l => {

            const leaveDate = new Date(l.fromdate);

            const employeeName =
                `${l.FirstName} ${l.LastName}`.toLowerCase();

            const matchesManager =
                !manager ||
                String(l.ManagerID) === String(manager);

            const matchesFrom =
                !fromDate ||
                leaveDate >= new Date(fromDate);

            const matchesTo =
                !toDate ||
                leaveDate <= new Date(toDate);

            const matchesEmployee =
                !employeeSearch ||
                employeeName.includes(
                    employeeSearch.toLowerCase()
                );

            return (
                matchesManager &&
                matchesFrom &&
                matchesTo &&
                matchesEmployee
            );

        });

    }, [
        leaves,
        manager,
        fromDate,
        toDate,
        employeeSearch
    ]);
    // SUMMARY
    const summary = useMemo(() => {

        return {
            approved: filteredLeaves.filter(
                l => l.Status === "1"
            ).length,

            rejected: filteredLeaves.filter(
                l => l.Status === "2"
            ).length,

            pending: filteredLeaves.filter(
                l =>
                    l.Status === "0" ||
                    l.Status === null
            ).length
        };

    }, [filteredLeaves]);

    // EMPLOYEE GROUPING
    const employeeWise = useMemo(() => {

        const grouped = {};

        filteredLeaves.forEach(l => {

            const emp =
                `${l.FirstName} ${l.LastName}`;

            if (!grouped[emp]) {
                grouped[emp] = [];
            }

            grouped[emp].push(l);

        });

        return grouped;

    }, [filteredLeaves]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className={`managerwiseleavereport-container ${theme}`}>

            {/* TOP HEADER */}
            <div className="managerwiseleavereport-topbar">

                {/* LEFT */}
                <div className="managerwiseleavereport-leftsection">

                    <button
                        className="managerwiseleavereport-backbtn"
                        onClick={() => navigate(-1)}
                    >
                        ← Back To Leave Management
                    </button>

                </div>

                {/* CENTER */}
                <div className="managerwiseleavereport-centersection">

                    <h1 className="managerwiseleavereport-title">
                        Manager Leave Report
                    </h1>

                    <p className="managerwiseleavereport-subtitle">
                        Analyze employee leave requests based on manager and duration
                    </p>

                </div>

                {/* RIGHT */}
                <div className="managerwiseleavereport-rightsection">

                    <button
                        className="managerwiseleavereport-themebtn"
                        onClick={() =>
                            setTheme(
                                theme === "dark"
                                    ? "light"
                                    : "dark"
                            )
                        }
                    >

                        {
                            theme === "dark"
                                ? "☀ Light Mode"
                                : "🌙 Dark Mode"
                        }

                    </button>

                </div>

            </div>

            {/* FILTER CARD */}
            <div className="managerwiseleavereport-filtercard">

                <div className="managerwiseleavereportfiltergrid">

                    {/* MANAGER */}
                    <div className="managerwiseleavereportfiltergroup">

                        <label
                            style={{
                                color: theme === "dark"
                                    ? "#ffffff"
                                    : "#6b7280",
                                fontWeight: "700",
                                letterSpacing: "1px",
                                textTransform: "uppercase",
                                fontSize: "0.78rem"
                            }}
                        >
                            Select Manager
                        </label>

                        <select
                            value={manager}
                            onChange={(e) =>
                                setManager(e.target.value)
                            }
                            className="managerwiseleavereportselect"
                        >

                            <option value="">
                                Choose Manager
                            </option>

                            {managers.map((m, idx) => (

                                <option
                                    key={idx}
                                    value={m.id}
                                >
                                    {m.name}
                                </option>

                            ))}

                        </select>

                    </div>

                    {/* FROM DATE */}
                    <div className="managerwiseleavereportfiltergroup">

                        <label>
                            From Date
                        </label>

                        <div className="managerwiseleavereportdatewrapper">

                            <span
                                className="managerwiseleavereportcalendaricon"
                                onClick={() => fromDateRef.current?.showPicker()}
                            >
                                📅
                            </span>

                            <input
                                ref={fromDateRef}
                                type="date"
                                value={fromDate}
                                onChange={(e) =>
                                    setFromDate(e.target.value)
                                }
                                className="managerwiseleavereportinput"
                            />

                        </div>

                    </div>

                    {/* TO DATE */}
                    <div className="managerwiseleavereportfiltergroup">

                        <label>
                            To Date
                        </label>

                        <div className="managerwiseleavereportdatewrapper">

                            <span
                                className="managerwiseleavereportcalendaricon"
                                onClick={() => toDateRef.current?.showPicker()}
                            >
                                📅
                            </span>

                            <input
                                ref={toDateRef}
                                type="date"
                                value={toDate}
                                onChange={(e) =>
                                    setToDate(e.target.value)
                                }
                                className="managerwiseleavereportinput"
                            />

                        </div>

                    </div>

                </div>

            </div>

            {/* ONLY SHOW DATA AFTER FILTER */}
            {(manager && fromDate && toDate) && (

                <>

                    {/* SUMMARY */}
                    <div className="managerwiseleavereport-summarygrid">

                        {/* APPROVED */}
                        <div className="managerwiseleavereport-summarycard approved">

                            <div className="managerwiseleavereport-summarylabel">
                                Approved
                            </div>

                            <div className="managerwiseleavereport-summaryvalue">
                                {summary.approved}
                            </div>

                        </div>

                        {/* REJECTED */}
                        <div className="managerwiseleavereport-summarycard rejected">

                            <div className="managerwiseleavereport-summarylabel">
                                Rejected
                            </div>

                            <div className="managerwiseleavereport-summaryvalue">
                                {summary.rejected}
                            </div>

                        </div>

                        {/* PENDING */}
                        <div className="managerwiseleavereport-summarycard pending">

                            <div className="managerwiseleavereport-summarylabel">
                                Pending
                            </div>

                            <div className="managerwiseleavereport-summaryvalue">
                                {summary.pending}
                            </div>

                        </div>

                    </div>

                    {/* LEAVE HISTORY TABLE */}
                    <div className="managerwiseleavereport-tablecard">

                        <div
                            className="managerwiseleavereport-tableheader"
                            style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "20px"
                            }}
                        >

                           <div
    style={{
        textAlign: "center"
    }}
>

    

    <p
    style={{
        marginTop: "10px",
        marginBottom: "18px",
        fontSize: "1.5rem",
        fontWeight: "600",
        color:
            theme === "dark"
                ? "#468ae8"
                : "#4377e0"
    }}
>
    Manager :
    {" "}
    {
        managers.find(
            m => String(m.id) === String(manager)
        )?.name
    }
</p>

<h2
    style={{
        margin: 0,
        fontSize: "1.4rem",
        fontWeight: "700",
        letterSpacing: "0.5px",
        color:
            theme === "dark"
                ? "#ffffff"
                : "#111827"
    }}
>
    Employee Leave History
</h2>

</div>
                            {/* SEARCH BOX RIGHT SIDE */}
                            <input
                                type="text"
                                placeholder="Search employee..."
                                value={employeeSearch}
                                onChange={(e) =>
                                    setEmployeeSearch(e.target.value)
                                }
                                className="managerwiseleavereportinput"
                                style={{
                                    position: "absolute",
                                    right: "0",
                                    width: "260px",
                                    height: "42px",
                                    color: theme === "dark" ? "#ffffff" : "#111827",
                                    WebkitTextFillColor:
                                        theme === "dark"
                                            ? "#ffffff"
                                            : "#111827",
                                    background:
                                        theme === "dark"
                                            ? "rgba(255,255,255,0.08)"
                                            : "#ffffff",
                                    border:
                                        theme === "dark"
                                            ? "1px solid rgba(255,255,255,0.12)"
                                            : "1px solid #d1d5db"
                                }}
                            />

                        </div>


                        <table className="managerwiseleavereport-historytable">
                            <thead>

                                <tr>

                                    <th>
                                        Sr No
                                    </th>

                                    <th>
                                        Employee Name
                                    </th>

                                    <th>
                                        Leave Unit
                                    </th>

                                    <th>
                                        Leave Type
                                    </th>

                                    <th>
                                        Duration
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                {filteredLeaves.length > 0 ? (

                                    filteredLeaves.map((leave, i) => (

                                        <tr key={i}>

                                            <td>
                                                {i + 1}
                                            </td>

                                            <td>
                                                {leave.FirstName}
                                                {" "}
                                                {leave.LastName}
                                            </td>

                                            <td>
                                                {leave.total}
                                            </td>

                                            <td>
                                                {leave.leavetype}
                                            </td>

                                            <td>
                                                {leave.fromdate}
                                                {" "}
                                                →
                                                {" "}
                                                {leave.todate}
                                            </td>

                                            <td>

                                                <span
                                                    className={`managerwiseleavereport-status ${leave.Status === "1"
                                                        ? "approved"
                                                        : leave.Status === "2"
                                                            ? "rejected"
                                                            : "pending"
                                                        }`}
                                                >

                                                    {
                                                        leave.Status === "1"
                                                            ? "Approved"
                                                            : leave.Status === "2"
                                                                ? "Rejected"
                                                                : "Pending"
                                                    }

                                                </span>

                                            </td>

                                        </tr>

                                    ))

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            style={{
                                                textAlign: "center",
                                                padding: "30px"
                                            }}
                                        >
                                            No leave records found
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </>

            )}

        </div>
    );
};

export default LeaveReport;